import { Injectable, signal, WritableSignal } from '@angular/core';

export type signalDataDashboard = 
{
  nb_clos : WritableSignal<number | null>
  nb_en_cours : WritableSignal<number | null>
  nb_hors_delai : WritableSignal<number | null>
  nb_message_non_lus : WritableSignal<number | null>
  nb_prematures : WritableSignal<number | null>
  nb_document : WritableSignal<number | null>
  nb_message : WritableSignal<number | null>
  nb_document_dip : WritableSignal<number | null>
  nb_message_dip : WritableSignal<number | null>
}

export type DashboardSignalKey = keyof signalDataDashboard

@Injectable({
  providedIn: 'root'
})
export class SignalService 
{
  data:signalDataDashboard = 
  {
    nb_clos : signal<number | null>(null),
    nb_en_cours : signal<number | null>(null),
    nb_hors_delai : signal<number | null>(null),
    nb_message_non_lus : signal<number | null>(null),
    nb_prematures : signal<number | null>(null),
    nb_document : signal<number | null>(null),
    nb_message : signal<number | null>(null),
    nb_document_dip : signal<number | null>(null),
    nb_message_dip : signal<number | null>(null),
  }

  constructor() { }

  setData(key: DashboardSignalKey, value: number | null) 
  {
    this.data[key].set(value)
  }

  // renvoie le WritableSignal (pour s'abonner dans le template ou appeler .set/.update)
  getSignal(key: DashboardSignalKey): WritableSignal<number | null> 
  {
    return this.data[key]
  }

  // renvoie la valeur courante
  getValue(key: DashboardSignalKey): number | null 
  {
    return this.data[key]()
  }
}
